import { jarvisApi } from './jarvis-api'
import store from '../store/store'

export default class DriveApi {
  static getTree () {
    return jarvisApi.get(
      '/drive/shares',
      {
        params:
          {
            law_firm_id: store.getters.currentLawFirm.id
          }
      }
    )
  }

  static download (file) {
    return jarvisApi.get(
      '/drive/stream/downloadFile',
      {
        params:
        {
          law_firm_id: store.getters.currentLawFirm.id,
          path: file.data.path
        },
        responseType: 'arraybuffer'
      }
    )
  }

  static delete (file) {
    return jarvisApi.delete(
      '/drive/deleteFile',
      {
        params:
        {
          law_firm_id: store.getters.currentLawFirm.id,
          path: file.data.path
        }
      }
    )
  }
}
